import React from "react";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { useTranslation } from "react-i18next";
import LoadingPlaceholder from "../LoadingPlaceholder";

const ToothFairyLoadingPlaceholder = ({
  caption = "messages.loadingApp",
  style,
  brandedAnimation = true,
  textStyle = null,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const { t } = useTranslation();
  return (
    <LoadingPlaceholder
      brandedAnimation={brandedAnimation}
      caption={t(caption)}
      visible={true}
      textStyle={textStyle}
      style={[
        {
          position: "absolute",
          zIndex: 10,
          height: "100%",
          width: "100%",
          backgroundColor: currentTheme?.theme?.backgroundColor,
        },
        style,
      ]}
    />
  );
};

export default ToothFairyLoadingPlaceholder;
